var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeatsTranscription = function SvgBeatsTranscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.22 3.45h3.455v-1H10.22zM10.22 6.904h3.455v-1H10.22zM2.447 10.358h3.455v-1H2.447zM10.22 10.358h3.455v-1H10.22zM2.447 13.813h3.455v-1H2.447zM10.22 13.813h3.455v-1H10.22zM2.447 17.268h3.455v-1H2.447zM10.22 17.268h3.455v-1H10.22zM17.993 17.268h3.454v-1h-3.454zM2.447 20.722h3.455v-1H2.447zM10.22 20.722h3.455v-1H10.22zM17.993 20.722h3.454v-1h-3.454z"
  })));
};
export default SvgBeatsTranscription;